function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 957 291",
  shapeRendering: "geometricPrecision",
  textRendering: "geometricPrecision",
  imageRendering: "optimizeQuality",
  fillRule: "evenodd",
  clipRule: "evenodd"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  gradientUnits: "userSpaceOnUse",
  x1: "136.97",
  y1: "282.882",
  x2: "136.97",
  y2: "7.739"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0",
  stopColor: "#4a3d52"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".188",
  stopColor: "#4f3b50"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".451",
  stopColor: "#942b45"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".549",
  stopColor: "#dd1b38"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".788",
  stopColor: "#e41b39"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#eb1c3a"
}))), /*#__PURE__*/React.createElement("path", {
  d: "M65 25C45 38 30 55 18 73l-3 6v2c-3 5-5 10-6 16-32 97 26 175 106 189 48 9 95-7 127-38 3-3 34-36 32-66-16 29-52 51-96 59h-2c-10 1-19 2-29 2-35 0-64-9-85-24-23-13-40-32-48-53 15 20 40 37 70 46-16-15-26-37-26-62 0-20 6-37 16-51l1-1c2-3 4-5 6-8 12-12 26-20 43-23 17-6 37-7 55-6 42 3 61 21 65 25 1-1 3-3 4-7 4-8 4-20 4-20 2 4 3 9 3 14 0 4-1 8-2 11 0 2-1 3-1 4-21 47-104 45-133 35-2-1-5-2-7-3 0-1-1-1-1-1-8-4-15-10-20-17-9 19-10 38-9 52 2 10 8 20 18 25 29 16 69 16 92 12 22-3 41-13 56-32 15-18 20-38 21-55 0-11 0-27-9-43-4-7-11-14-17-20-7-7-24-20-41-28-18-8-38-11-58-11-27 0-55 7-79 23z",
  fill: "url(#a)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M782 134h32V60l57 74h22V0h-31v72L805 0h-23v134zm-104 0h82v-28h-51V80h45V53h-45V27h49V0h-80v134zm-88 0h31V29h42V0H549v29h41v105zm-132 0h31V85h38V58h-38c0-17 14-29 31-29h11V0h-10c-35 0-63 28-63 63v71zm-104 0h81v-28h-50V80h44V53h-44V27h48V0h-79v134zm32 131h43v24h-75V156h32v109zm90-109v133h-32V156h32zm48 0l32 100 33-100h34l-46 133h-42l-46-133h35zm144 0v133h-32V156h32zm141 133h-32l-54-81v81h-33V156h33l54 83v-83h32v133zm85-134c16 0 30 4 41 12s18 19 20 33h-34c-2-5-6-8-10-11-5-3-11-4-17-4-10 0-18 3-25 10-6 7-9 16-9 28s3 22 10 29c6 7 16 10 28 10 7 0 14-2 20-6s10-10 12-18h-41v-23h68v31c-3 8-7 15-12 22-6 7-13 12-21 16-9 5-19 7-30 7-13 0-25-3-35-9s-18-14-23-24c-6-10-9-22-9-35 0-14 3-25 9-36 5-10 13-18 23-24 10-5 21-8 35-8z",
  fill: "#4a3d52"
}));